import './Landing.scss';
import { Button } from 'primereact/button';
import React from 'react';


const FEATURE_LIST = [
  'AI lab',
  'Access control',
  'Auditing',
  'Cohort tools',
  'Cryptographic key management',
  'Custom integration options',
  'Disaster recovery',
  'Environment version control',
  'Firmware OTA updates',
  'Fleet management',
  'Integrations with third party systems',
  'Regulatory submission tools',
];


class Landing extends React.Component {
  render() {
    return (
      <div className='Landing'>
        <div className='section'>
          <div className='subtitle'>
            Speed up your medical device development time
          </div>
          <p>
            Our software functions as a Class A module, allowing you to reach clinical trials and commercialization 3-6 months sooner.
          </p>
        </div>
        <div className='section'>
          <div className='p-grid'>
            <div className='p-col-4'>
              <div className='featureName'>
                Less time, lower cost
              </div>
              <div className='featureDescription'>
                Leveraging a plug-and-play software platform dramatically reduces development time, compared to building in-house.
              </div>
            </div>
            <div className='p-col-4'>
              <div className='featureName'>
                Security that's always up to date
              </div>
              <div className='featureDescription'>
                Our security experts track threats, leaving you with one less risk to worry about.
              </div>
            </div>
            <div className='p-col-4'>
              <div className='featureName'>
                HIPAA? We've got that
              </div>
              <div className='featureDescription'>
                Our software complies with all applicable regulations, so you can market your devices in the U.S. and Europe.
              </div>
            </div>
          </div>
        </div>
        <div className='section'>
          <div className='featureName'>
            Explore the full platform
          </div>
          <div className='featureDescription'>
            <div className='p-grid'>
              {FEATURE_LIST.map(i => (
                <div className='p-col-3 smallFeature' key={i}>
                  <div className='smallFeatureBullet' />
                  <div className='smallFeatureText'>{i}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className='section'>
          <div className='right'>
            <Button label='Learn more' icon='pi pi-arrow-right' iconPos='right' />
          </div>
        </div>
      </div>
    );
  }
}


export default Landing;
